import React, { useState } from 'react';

import Icon from '../../../molecules/Icon';
import CategoryButton from './CategoryButton';

import { formattedFilter } from '../utils/functions';

import { color } from '../../../atoms/colors';
import {
  Container,
  Button,
  Filters,
  OrderButton,
} from '../styles/MobileFilterGroup.styled';

const MobileFilterGroup = ({
  filter,
  activeFilters,
  setActiveFilters,
  sortOrder,
  setSortOrder,
}) => {
  const [expanded, setExpanded] = useState(false);

  if (!filter) return null;

  const { categories, title } = filter;

  return (
    <Container className="mobile-filter-group" expanded={expanded}>
      <Button
        key={title}
        type="button"
        expanded={expanded}
        onClick={() => setExpanded(!expanded)}
      >
        <div className="filter-heading">
          {title}
          {activeFilters[formattedFilter(title)]?.length > 0 && (
            <span className="count">
              {activeFilters[formattedFilter(title)]?.length}
            </span>
          )}
        </div>
        <Icon
          id="chevron-down"
          width="20px"
          height="20px"
          fillColor={color.darkBlue[900]}
        />
      </Button>
      <Filters expanded={expanded}>
        {categories?.map(category => {
          const filterFormatted = formattedFilter(filter.title);
          const isActive = activeFilters[filterFormatted]?.includes(category);

          if (title === 'Sort By') {
            return (
              <OrderButton
                onClick={() => setSortOrder(category)}
                active={sortOrder === category}
              >
                {category}
              </OrderButton>
            );
          }
          return (
            <CategoryButton
              filter={filter}
              category={category}
              isActive={isActive}
              setActiveFilters={setActiveFilters}
            />
          );
        })}
      </Filters>
    </Container>
  );
};

export default MobileFilterGroup;
